import { NgModule } from '@angular/core';
import { RouteReuseStrategy, RouterModule, Routes } from '@angular/router';

import { ADMIN_ROUTES } from '~core/routing/admin.routes';
import { PUBLIC_ROUTES } from '~core/routing/public.routes';
import { CustomRouteReuseStategy } from '~utils/customRouterReloadStrategy.util';

const spaceForAllHeaders = 113;

const routes: Routes = [...ADMIN_ROUTES, ...PUBLIC_ROUTES];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
      scrollOffset: [0, -spaceForAllHeaders],
    }),
  ],
  exports: [RouterModule],
  providers: [{ provide: RouteReuseStrategy, useClass: CustomRouteReuseStategy }],
})
export class AppRouting {}
